module.exports = __webpack_public_path__ + "static/img/logo_jt_5.8764878.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_jt_5.png
// module id = Ht0T
// module chunks = 0